export enum ImageResizeMode {
    Contain = 'contain',
    Cover = 'cover',
    Fill = 'fill',
    Inside = 'inside',
    Outside = 'outside',
}
